/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Regenerate_BtnInputs */



/**
* | output |
* | --- |
* | "Regenerate" |
*
* @param {Developer_Regenerate_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_regenerate_btn = /** @type {((inputs?: Developer_Regenerate_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Regenerate_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Régénérer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Regenerar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Regenerar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rigenera")
	return /** @type {LocalizedString} */ ("Regenerate")
});